"use client"

import { useState } from "react"

import { SearchIcon, X } from "lucide-react"

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput
} from "@/components/ui/input-group"
import { GameResults } from "@/features/casino/components/search/GameResults"

import { searchTexts as t } from "./localization/texts"

export type SearchInputProps = {
  placeholder?: string
  variant?: "default" | "surface"
}

export function SearchInput({
  placeholder = t.placeholder,
  variant = "surface"
}: SearchInputProps = {}) {
  const [query, setQuery] = useState("")

  return (
    <section aria-label={placeholder} className="flex flex-col gap-4">
      <InputGroup variant={variant} className="focus-within:border-white/10">
        <InputGroupAddon align="inline-start" className="pl-3">
          <SearchIcon className="size-6 shrink-0 text-white/50" aria-hidden />
        </InputGroupAddon>
        <InputGroupInput
          className="pl-2 placeholder:text-white/30"
          value={query}
          onChange={(event) => {
            setQuery(event.target.value)
          }}
          placeholder={placeholder}
          aria-label={placeholder}
        />
        {query.length > 0 ? (
          <InputGroupAddon align="inline-end">
            <button
              type="button"
              onClick={() => {
                setQuery("")
              }}
              aria-label={t.clear}
              className="text-white/50"
            >
              <X className="size-5" aria-hidden />
            </button>
          </InputGroupAddon>
        ) : null}
      </InputGroup>
      <GameResults query={query} />
    </section>
  )
}
